import { useEffect, useState } from 'react'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { SECOND_MS } from '$func/time'

function millisecondsToSeconds(milliseconds: number) {
  return Math.round(milliseconds / 1000)
}

export function useCountDownToDate(dateMS: number, intervalMS = SECOND_MS) {
  const [diff, setDiff] = useState(
    millisecondsToSeconds(dateMS - dateWithOffset()),
  )

  useEffect(() => {
    setDiff(millisecondsToSeconds(dateMS - dateWithOffset()))

    const interval = setInterval(() => {
      const newDiff = dateMS - dateWithOffset()
      if (newDiff > 0) setDiff(millisecondsToSeconds(newDiff))
      else {
        clearInterval(interval)
        setDiff(0)
      }
    }, intervalMS)

    return () => {
      clearInterval(interval)
    }
  }, [dateMS, intervalMS])

  return diff
}
